import * as serverErrors from '../../models/serverErrors';

const errorMap = Object.keys(serverErrors).reduce((map, key) => {
  const error: serverErrors.IServerError = serverErrors[key];
  if (error.statusCode) {
    map[error.statusCode] = error;
  }
  return map;
}, {});

const defaultErrorMessage = 'An_error_occurred';

export const mapServerError = (incomingMessage, returnErrorsArray = false) => {
  const ErrorConstructor: serverErrors.IServerError =
    (incomingMessage.response && errorMap[incomingMessage.response.statusCode]) ||
    serverErrors.ServerError;
  const message =
    incomingMessage.body && incomingMessage.body.Message
      ? incomingMessage.body.Message
      : incomingMessage.response &&
        incomingMessage.response.body &&
        incomingMessage.response.body.Message
      ? incomingMessage.response.body.Message
      : incomingMessage.response && incomingMessage.response.statusMessage;

  if (!message && incomingMessage) {
    return incomingMessage;
  }

  const errorsArray = incomingMessage.response?.body?.Errors;
  if (returnErrorsArray && errorsArray) {
    return errorsArray;
  }

  return new ErrorConstructor(message || defaultErrorMessage);
};

export const mapServerErrorReject = (incomingMessage) =>
  Promise.reject(mapServerError(incomingMessage));
